import { render, staticRenderFns } from "./french_reading.vue?vue&type=template&id=927e2a4c&scoped=true"
import script from "./french_reading.vue?vue&type=script&lang=js"
export * from "./french_reading.vue?vue&type=script&lang=js"
import style0 from "./french_reading.vue?vue&type=style&index=0&id=927e2a4c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927e2a4c",
  null
  
)

export default component.exports